import React, { useState } from 'react';
import { LoginPage } from '../auth/LoginPage';
import { LandingPage } from './LandingPage';
import { GrandparentDashboardPage } from '../pages/GrandParentDashboardPage';
import { ParentDashboardPage } from '../pages/ParentDashboardPage';
import { RecordingPage } from '../pages/RecordingPage';
import { SignupPage } from '../auth/SignUp';
import { useNavigate } from 'react-router-dom';

const StorytimeApp = () => {
  const [currentPage, setCurrentPage] = useState('landing'); // START AT LANDING
  const [userData, setUserData] = useState(null);
  const [selectedBook, setSelectedBook] = useState(null);
  const [selectedUserType, setSelectedUserType] = useState(null); // Track which type they clicked
  const navigate = useNavigate();


  const handleSelectUserType = (type) => {
    setSelectedUserType(type);
    setCurrentPage('login');
  };

  const handleLogin = (credentials) => {
    console.log('Login attempt:', credentials);
    // Navigate to the actual route instead of setting state
    navigate(selectedUserType === 'grandparent' ? '/grandparent-dashboard' : '/parent-dashboard');
  };

  const handleSignup = (formData) => {
    console.log('Signup attempt:', formData);
    navigate(formData.userType === 'grandparent' ? '/grandparent-dashboard' : '/parent-dashboard');
  };


  const handleStartRecording = (book) => {
    setSelectedBook(book);
    setCurrentPage('recording');
  };

  const handleCancelRecording = () => {
    setSelectedBook(null);
    setCurrentPage('grandparent-dashboard');
  };

  // Route rendering
  if (currentPage === 'landing') {
    return <LandingPage onSelectUserType={handleSelectUserType} onNavigateToSignup={() => setCurrentPage('signup')}/>;
  }

  if (currentPage === 'login') {
    return <LoginPage 
      onLogin={handleLogin} 
      onNavigateToSignup={() => setCurrentPage('signup')}
      userType={selectedUserType} 
    />;
  }

  if (currentPage === 'signup') {
    return <SignupPage 
      onSignup={handleSignup} 
      onNavigateToLogin={() => setCurrentPage('login')}
      preselectedUserType={selectedUserType}
    />;
  }

  if (currentPage === 'grandparent-dashboard') {
    return <GrandparentDashboardPage userData={userData} onStartRecording={handleStartRecording} />;
  }

  if (currentPage === 'parent-dashboard') {
    return <ParentDashboardPage userData={userData} />;
  }


  return null;
};

export default StorytimeApp;